<div class="card sm:pt-2 border-round-2xl hover:surface-500 cursor-pointer px-3" style="min-width: 20rem;"
	[ngClass]="cardsBgColor(site)">
	<div class="flex flex-row align-items-center justify-content-between">
		<div class="flex flex-column w-full" (click)="selectSite()">
			<p class="my-1 font-semibold text-xl" [pTooltip]="site.Name.length > 20 ? site.Name : ''"
				tooltipPosition="bottom">{{ site.Name | truncate:[20] }}</p>
			<p class="" [pTooltip]="site.Description.length > 27 ? site.Description: ''" tooltipPosition="bottom">
				{{ site.Description.length > 0 ? ( site.Description | truncate:[27] ): 'NO_DESCRIPTION' | translate }}
			</p>
		</div>
		<!-- MENU BUTTON -->
		<div *ngIf="!fromDialogSelector" class="flex">
			<button pButton pRipple icon="pi cm-ellipsis-v" class="p-button-text text-color border-circle hover:bg-primary"
				(click)="menu.toggle($event)"></button>
			<p-menu #menu [popup]="true" appendTo="body" [model]="menuitems"></p-menu>
		</div>
	</div>
	<div id="siteCardImageContainer" class="flex my-3 align-items-center justify-content-center" (click)="selectSite()">
		<img id="siteCardImage" class="border-round-lg" [src]="imageSource().src">
	</div>
	<div class="flex flex-row align-items-center justify-content-start mt-2" (click)="selectSite()">
		<i class="pi cm-device-connected-small text-2xl"></i>
		<div class="font-normal ml-2">{{ 'DEVICES_INSTALLED' | translate }}: {{
			site.Devices !== undefined ? site.Devices.length : 1 }}</div>
	</div>
	<div class="flex flex-row align-items-center justify-content-start mt-2" (click)="selectSite()">
		<i class="pi cm-marker text-2xl" [pTooltip]="site.Address.length > 27 ? site.Address : ''"
			tooltipPosition="bottom"></i>
		<div class="font-normal ml-2" [pTooltip]="site.Address.length > 27 ? site.Address : ''" tooltipPosition="bottom">
			{{ site.Address || ('ADDRESS_NOT_DEFINED' | translate) | truncate:[27] }}
		</div>
	</div>
	<!-- TIMEZONE SETTED -->
	<div *ngIf="site.Timezone !== undefined && site.Timezone !== null && site.Timezone !== ''" class="flex flex-row align-items-center justify-content-start mt-2" (click)="selectSite()">
		<i class="pi pi-globe text-2xl" [pTooltip]=" site.Timezone.length > 27 ? site.Timezone : ''" tooltipPosition="bottom"></i>
		<div class="font-normal ml-2" [pTooltip]="site.Timezone.length > 27 ? site.Timezone : ''" tooltipPosition="bottom">
			{{ site.Timezone | truncate:[27] }}
		</div>
	</div>
	<!-- TIMEZONE NOT SETTED -->
	<div *ngIf="site.Timezone === undefined || site.Timezone === null || site.Timezone === ''" class="flex flex-row align-items-center justify-content-start mt-2" (click)="selectSite()">
		<i class="pi pi-globe text-2xl" [pTooltip]="('ADD_TIMEZONE_SITE' | translate)" tooltipPosition="bottom"></i>
		<div class="font-normal ml-2" [pTooltip]="('ADD_TIMEZONE_SITE' | translate)" tooltipPosition="bottom">
			{{ 'ADD_TIMEZONE_SITE' | translate | truncate:[27] }}
		</div>
	</div>
	<div class="grid mx-0" (click)="selectSite()">
		<div class="col-6 flex flex-column pt-4 pb-2">
			<div class="flex justify-content-center text-2xl">{{ getDeviceOnline() }}</div>
			<div class="flex justify-content-center"><p-tag [value]="('ONLINE' | translate)" severity="success"></p-tag>
			</div>
		</div>
		<div class="col-6 flex flex-column pt-4 pb-2">
			<div class="flex justify-content-center text-2xl">{{ getDeviceOffline() }}</div>
			<div class="flex justify-content-center"><p-tag [value]="('OFFLINE' | translate)" severity="danger"></p-tag>
			</div>
		</div>
	</div>

	<div *ngIf="site.CurrentlyOwned && site.TechnicianId" class="alert alert-warning clickable pt-2"
		(click)="goToSupport()" [pTooltip]="!impersMode ? ('VIEW_TECHNICIAN' | translate) : ''" tooltipPosition="bottom">
		<p-tag severity="warning" styleClass="w-full h-3_5rem gap-3">
			<i class="pi cm-technician text-2xl"></i>
			<div class="flex flex-column">
				<span>{{ 'TECH_ASSOCIATED' | translate | truncate:[27] }}:</span>
				<span>{{ getTechInfo() | truncate:[25] }}</span>
			</div>
		</p-tag>
	</div>
	<div *ngIf="site.CurrentlyOwned && !site.TechnicianId" class="alert alert-warning clickable pt-2"
		(click)="goToSupport()" pTooltip="{{ 'VIEW_TECHNICIAN' | translate }}" tooltipPosition="bottom">
		<p-tag styleClass="p-tag-darkBlue10 w-full h-3_5rem gap-3">
			<i class="pi cm-technician text-2xl"></i>
			<div class="flex flex-column">
				<!-- <span *ngIf="!isRussian()">{{ 'TECHNICIAN' | translate }}:</span> -->
				<span>{{ 'NO_TECHNICIAN' | translate | truncate:[27] }}</span>
			</div>
		</p-tag>
	</div>
	<div *ngIf="!site.CurrentlyOwned && !site.isOnlySiteVct" class="alert alert-primary clickable pt-2"
		(click)="selectSite()" pTooltip="{{ 'VIEW_SHARED_DEVICES' | translate }}" tooltipPosition="bottom">
		<p-tag styleClass="p-tag-purple w-full h-3_5rem gap-3">
			<i class="pi cm-share text-xl"></i>
			<div class="flex flex-column">
				<span *ngIf="!site.User">{{ 'SHARED_SITE' | translate | truncate:[27] }}:</span>
				<span *ngIf="site.User">{{ 'SHARED_SITE_FROM' | translate | truncate:[27] }}:</span>
				<span *ngIf="site.User">{{site.User.FirstName + ' ' + site.User.LastName | truncate:[20]}}</span>
			</div>
		</p-tag>
	</div>
	<!-- NOTE: VCT SITE OWNED IS A NORMAL SITE (Automation + Thermo + Vct) -->
	<!-- VCT SITE SHARED -->
	<div *ngIf="isVctSharedSite(site)" class="alert alert-primary clickable pt-2" (click)="selectSite()"
		pTooltip="{{ 'VIEW_SHARED_DEVICES' | translate }}" tooltipPosition="bottom">
		<p-tag styleClass="p-tag-purple w-full h-3_5rem gap-3">
			<i class="pi cm-derivate text-xl"></i>
			<div class="flex flex-column">
				<span>{{ 'SITES_VCT_USER' | translate | truncate:[27] }}</span>
				<span>{{ 'SHARED_SITE' | translate | truncate:[27] }}</span>
			</div>
		</p-tag>
	</div>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>